import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * BFS nodes and execute callback.
 */
function bfs(node, callback) {
  var discovered = [node];
  while (discovered.length) {
    var currentNode = discovered.shift();
    callback && callback(currentNode);
    var children = currentNode.children || [];
    var _iterator = _createForOfIteratorHelper(children),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        discovered.push(child);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}
/**
 * Hierarchy container.
 */
export var Node = /*#__PURE__*/function () {
  function Node() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var type = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck(this, Node);
    // The parent node.
    this.parentNode = null;
    // The children nodes.
    this.children = [];
    // The index of parent children.
    this.index = 0;
    this.type = type;
    this.value = value;
  }
  /**
   * Apply specified transform to current value. Mount the node
   * to replace the original one in the tree and then return it.
   */
  _createClass(Node, [{
    key: "map",
    value: function map() {
      var transform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (x) {
        return x;
      };
      var newValue = transform(this.value);
      this.value = newValue;
      return this;
    }
    /**
     * Set or get the specified attribute. It the value is specified, update
     * the attribute of current value and return the node. Otherwise
     * return the the attribute of current value.
     */
  }, {
    key: "attr",
    value: function attr(key, value) {
      if (arguments.length === 1) return this.value[key];
      return this.map(function (v) {
        return v[key] = value, v;
      });
    }
    /**
     * Create a new node and append to children nodes.
     */
  }, {
    key: "append",
    value: function append(Ctor) {
      var node = new Ctor({});
      node.children = [];
      this.push(node);
      return node;
    }
  }, {
    key: "push",
    value: function push(node) {
      node.parentNode = this;
      node.index = this.children.length;
      this.children.push(node);
      return this;
    }
    /**
     * Remove current node from parentNode.
     */
  }, {
    key: "remove",
    value: function remove() {
      var _this = this;
      var parent = this.parentNode;
      if (parent) {
        var children = parent.children;
        var index = children.findIndex(function (item) {
          return item === _this;
        });
        children.splice(index, 1);
      }
      return this;
    }
  }, {
    key: "getNodeByKey",
    value: function getNodeByKey(key) {
      var targetNode = null;
      var callback = function callback(node) {
        if (key === node.attr('key')) {
          targetNode = node;
        }
      };
      bfs(this, callback);
      return targetNode;
    }
  }, {
    key: "getNodesByType",
    value: function getNodesByType(type) {
      var nodes = [];
      var callback = function callback(node) {
        if (type === node.type) {
          nodes.push(node);
        }
      };
      bfs(this, callback);
      return nodes;
    }
  }, {
    key: "getNodeByType",
    value: function getNodeByType(type) {
      var node = null;
      bfs(this, function (current) {
        if (node) return;
        if (type === current.type) node = current;
      });
      return node;
    }
    /**
     * Apply specified callback to the node value.
     */
  }, {
    key: "call",
    value: function call(callback) {
      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }
      callback.apply(void 0, [this.map()].concat(params));
      return this;
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      // Find the root chart and render.
      var root = this;
      while (root && root.parentNode) {
        root = root.parentNode;
      }
      return root;
    }
  }]);
  return Node;
}();